module.exports = __webpack_public_path__ + "img/virgo.516677b6.png";